import type { ReactNode } from "react";
import type { GlassTheme } from "./glass";

/** En-tête des blocs en verre : pastille d'icône teintée selon le fond + titre. */
export const GlassBlockHeader = ({
  theme,
  icon,
  title,
}: {
  theme: GlassTheme;
  icon: ReactNode;
  title: string;
}) => (
  <header className="flex items-center gap-3">
    <span
      className="flex size-10 shrink-0 items-center justify-center rounded-md"
      style={theme.iconBox}
    >
      {icon}
    </span>
    <h2 className="text-xl font-semibold">{title}</h2>
  </header>
);
